import { defineStore } from 'pinia';
import { ElMessageBox } from "element-plus";
import router from '../router';
import { locale } from "../js/sakura";
import { GlobalLoader } from '../../src/api/Fetch'

import { useDeviceStore, useMulticastStore, useNeighborStore,
    useNetworksStore, usePoeStore, useConfigurationStore,
    useLogsStore, useSecurityStore, useStatisticsStore,
    useMirroringStore, useAuthStore, useFirmwareStore } from './index';
export const useWebSocketStore = defineStore('websocket', {
    state: () => ({
        socket: null,
        isConnected: false,
        messages: [],
        retryCount: 0,
        maxRetries: 3,
        lastMessageTime: null,
        heartbeatInterval: null,
        heartbeatTimeout: 300000,
        logoutTriggered: false,
        tempResponse: '',
        isLogin: false,
        isReload: sessionStorage.getItem('isReload') === 'true' || false,
        idleTimeout: 2 * 60 * 60 * 1000,
        idleTimer: null,
    }),
    actions: {
        startIdleTracking() {
            const resetTimer = () => {
                clearTimeout(this.idleTimer);
                this.idleTimer = setTimeout(() => {
                sessionStorage.clear();
                this.message(router, `${locale.global.logout.message}`);
                }, this.idleTimeout);
            };
            this._resetIdle = resetTimer;
            ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'].forEach(e =>
                window.addEventListener(e, resetTimer)
            );
            resetTimer();
        },
        stopIdleTracking() {
            clearTimeout(this.idleTimer);
            if (this._resetIdle) {
                ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'].forEach(e =>
                window.removeEventListener(e, this._resetIdle)
                );
                this._resetIdle = null;
            }
        },
        connectWebSocket() {
            this.startIdleTracking()
            if (this.isReload || router.currentRoute.value.name === 'login') {
                GlobalLoader.start();
            } else {
                GlobalLoader.stop();
            }

           const sessionToken = sessionStorage.getItem('token');
            if (!sessionToken) {
                console.warn("No session token found. Skipping WebSocket connection.");
                return;
            }

            if (this.retryCount >= this.maxRetries) {
                console.warn("Max retry attempts reached. WebSocket not connected. Logging out");
                this.logoutTriggered = true;
                this.stopIdleTracking();
                this.message(router, `${locale.global.logout.message} (1011)`)
               return;
           }

            if (this.socket) return; // Prevent multiple connections

            var url = new URL(location.href);
            var ipAddress = url.hostname;
            const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
            const wsUrl = `${protocol}//${ipAddress}:4443/websocket`;

            this.socket = new WebSocket(wsUrl);
            this.socket.addEventListener('open', () => {
                console.log('WebSocket new connection enabled', this.socket);
                this.isConnected = true;
                this.lastMessageTime = Date.now();
                this.startHeartbeat();

                this.sendPageRequest(window.location.pathname);
                const request = {
                    message_type: 0,
                    resource_list: [
                        'radius_port_config',
                        'device_info',
                        'device_time',
                        'special_interface_route',
                        'vlan_list',
                        'swcfg_port',
                    ],
                };
                this.socket.send(JSON.stringify(request));
            });

            this.socket.addEventListener("message", (event) => {
                this.lastMessageTime = Date.now();
                this.retryCount = 0;
                // Split using regex between JSON objects
                const jsonStrings = event.data
                .split(/(?<=\})\s*(?=\{)/g)  // regex that finds closing } followed by opening {
                .filter(Boolean);

                jsonStrings.forEach((jsonStr, index) => {
                try {
                    const response = this.isJsonString(jsonStr) ? JSON.parse(jsonStr) : jsonStr;
                    // console.log("There is some new update", Object.keys(response), "@ "+ new Date());

                    if (response.hasOwnProperty('init_complete')) {
                        console.log('**********init_complete ************')
                        const reloadTarget = sessionStorage.getItem('reloadTarget');
                        if (this.isReload && reloadTarget) {
                            sessionStorage.removeItem('isReload');
                            sessionStorage.removeItem('reloadTarget');
                            this.isReload = false;
                            if (reloadTarget && router.currentRoute.value.fullPath !== reloadTarget) {
                                router.replace(reloadTarget.replace(/^#/, '')).catch(() => {});
                            }
                        } else if(router.currentRoute.value.name === 'login') {
                            router.push("/configure/overview");
                        }
                        // GlobalLoader.stop();
                        GlobalLoader.reset();
                    }

                    // check if fragmentation and acc all data
                    if(!(jsonStr.includes("resp") && jsonStr.includes("respCode"))) {
                        this.tempResponse += this.toJSONString(jsonStr);
                        return;
                    }

                    //check if
                    if(response.resp || (jsonStr.includes("resp") && jsonStr.includes("respCode"))){
                        // fragmentation success
                        if(this.tempResponse != ''){
                            this.tempResponse += this.toJSONString(jsonStr);

                            const response1 = this.isJsonString(this.tempResponse) ? JSON.parse(this.tempResponse) : this.tempResponse;
                            this.pushDatatoStore(response1);
                            this.tempResponse = '';
                            return;
                        }
                        this.tempResponse = '';
                    }

                    this.pushDatatoStore(response);
                } catch (err) {
                    console.error("Invalid JSON block:", err, event.data);
                }
                });


            });

            this.socket.addEventListener('close', () => {
                console.log('WebSocket closed');
                this.socket = null;
                this.isConnected = false;
                this.stopHeartbeat();

                const token = sessionStorage.getItem('token');
                if (token && (this.retryCount < this.maxRetries)) {
                    this.retryCount++;
                    setTimeout(() => this.connectWebSocket(), 5000);
                } else {
                    console.warn("WebSocket closed after being connected.");
                }
            });

            this.socket.addEventListener('error', (error) => {
                console.error('WebSocket error:', error);
            });
        },
        toJSONString(data) {
            if (typeof data === 'string') return data;

            try {
                return JSON.stringify(data);
            } catch (e) {
                return '';
            }
        },
        pushDatatoStore(response){
            if (response.resp?.respCode !== 0) {
                console.warn("WebSocket error or invalid response:", {response});
                return;
            }

            const deviceStore = useDeviceStore();
            const multicastStore = useMulticastStore();
            const neighborStore = useNeighborStore();
            const networksStore = useNetworksStore();
            const poeStore = usePoeStore();
            const configurationStore = useConfigurationStore();
            const logsStore = useLogsStore();
            const securityStore = useSecurityStore();
            const statisticsStore = useStatisticsStore();
            const mirroringStore = useMirroringStore();
            const authStore = useAuthStore();
            const firmwareStore = useFirmwareStore();

            // Mapping keys to store actions
            const mutationMap = {
                deviceInfo: deviceStore.setDeviceInfo,
                deviceTime: deviceStore.setDeviceTime,
                switchConfigVlan: deviceStore.setVlanList,
                switchSpecialInterface: deviceStore.setSwitchSpecialInterface,
                multicastGroups: multicastStore.setMultiCastGroups,
                lldpRemoteDevice: neighborStore.setLldpRemoteDevice,
                switchConfigAutoLag: networksStore.setAutoLagList,
                switchConfigLagGroup: deviceStore.setLagList,
                profileList: networksStore.setProfileList,
                switchPortConfig: networksStore.setPortList,
                poePortConfig: poeStore.setPoePortConfig,
                poeSchedule: poeStore.setPoeScheduleList,
                poeInfo: poeStore.setPoeInfo,
                swcfg_ports_status: configurationStore.setGlobalConfigurationList,
                bufferedLog: logsStore.setLogsData,
                loggingCfg: logsStore.setLogging,
                radiusConfig: securityStore.setRadiusInfo,
                radius_port_config: securityStore.setRadiusPortConfig,
                switchConfigManualTrunk: networksStore.setSwitchConfigManualTrunk,
                InPortStatistics: statisticsStore.setInPortStatistics,
                OutPortStatistics: statisticsStore.setOutPortStatistics,
                devicePortMirroring: mirroringStore.setDevicePortMirroring,
                switchVlanInterface: deviceStore.setManagementIpAddress,
                multicastModeConfig: multicastStore.setModePortList,
                stacking: authStore.setStacking,
                blockAddressList: multicastStore.setBlockAddressList,
                switchPtpCfg: networksStore.setSwitchPtpCfg,
                switchConfigAutoTrunk: networksStore.setAutoMode,
                imageInfo: firmwareStore.setImageInfo,
                profile: networksStore.setProfileTemplate,
            };

            for (const key in mutationMap) {
                if (response[key]) {
                    mutationMap[key](response[key]); // Call Pinia action
                    return;
                }
            }
        },
        isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        sendMessage(message) {
            if (this.socket && this.isConnected) {
                this.socket.send(JSON.stringify(message));
            }
        },
        startHeartbeat() {
            if (this.heartbeatInterval) clearInterval(this.heartbeatInterval);

            this.heartbeatInterval = setInterval(() => {
                if (!this.isConnected) return;

                const now = Date.now();
                if (now - this.lastMessageTime > this.heartbeatTimeout) {
                    console.warn("WebSocket inactive. Closing and retrying...");
                    if(this.socket){
                      const request = {
                        message_type: 6,
                      };
                      this.socket.send(JSON.stringify(request));
                      this.socket?.close(); // Triggers `onclose` and retry logic
                      this.socket = null;
                    }
                    this.isConnected = false;
                }
            }, 5000); // Check every 5s
        },

        stopHeartbeat() {
            if (this.heartbeatInterval) {
                clearInterval(this.heartbeatInterval);
                this.heartbeatInterval = null;
            }
        },
        sendPageRequest(path) {
            const pageRequests = {
                "/configure/overview": [
                    'radius_port_config',
                    'device_info',
                    'device_time',
                    'special_interface_route',
                    'vlan_list',
                    'swcfg_port',
                ],
                "/configure/network": [
                    "radius_port_config",
                    "special_interface_route",
                    "vlan_list",
                ],
            };

            const resource_list = pageRequests[path] || [];
            if (!this.socket || resource_list.length === 0) return;

            const request = {
                message_type: 0,
                resource_list,
            };
            this.socket.send(JSON.stringify(request));
        },
        message(router, msg) {
          ElMessageBox.alert(msg, locale.global.webSocketLogout.title, {
            type: 'warning',
            customClass: 'message-box-on-top commonalert',
            appendTo: document.body,
            showClose: false, callback: action => {
                router.push("/login");
              location.reload();
            }
          });
        },
        disconnectWebSocket() {
            if (this.socket) {
                const request = {
                  message_type: 6,
                };
                this.socket.send(JSON.stringify(request));
                console.log("websocket close trigger from FE disconnectWebSocket")
                this.socket.close();
                this.socket = null;
                this.isConnected = false;
            }
        },
    },
});
